import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'react-hot-toast';
import { toastConfig } from './config/toast';
import { HelmetProvider } from 'react-helmet-async';


const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <ThemeProvider>
          <AuthProvider>
            <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
              <Toaster
                position="bottom-center"
                reverseOrder={false}
                gutter={8}
                toastOptions={{
                  ...toastConfig,
                  success: {
                    style: {
                      ...toastConfig.style,
                      background: '#064e3b', // dark green
                    },
                  },
                  error: {
                    style: {
                      ...toastConfig.style,
                      background: '#7f1d1d', // dark red
                    },
                    duration: 4000,
                  },
                }}
              />
              <AppRoutes />

            </div>
          </AuthProvider>
        </ThemeProvider>
      </Router>
    </HelmetProvider>
  );
};

export default App;